import React from 'react';
import { styled } from 'linaria/react';
import CategoryContent from '../Util/CategoryContent';
import { convertPropsToObject } from '../ContentRender/ContentRender';
import Image from '@jetshop/ui/Image/Image';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { useIntl } from '@jetshop/intl';

const Wrapper = styled('div')`
  margin: 2rem 0;
  h3 {
    margin-bottom: 0.5rem;
  }
`;

export const ThemeCategory = ({ product }) => {
  const t = useIntl();

  if (!product) return null;

  const themeCategory = product.categories?.filter(
    (cat) =>
      product?.canonicalCategory?.primaryRoute?.path === cat.primaryRoute?.path
  )[0];

  if (!themeCategory) return null;

  return (
    <CategoryContent id={themeCategory.id}>
      {(category) => {
        const imageData = category?.data?.items?.filter(
          (item) => item.type === 'theme-image'
        )[0];

        if (!imageData) return null;

        const name = category.name;
        const props = convertPropsToObject(imageData);
        const aspect = props.imageAspectRatio.value;
        const src = props.themeImage.value;
        if (src)
          return (
            <Wrapper>
              <h3>
                {t('See everything from {name} here ', {
                  name,
                })}
              </h3>
              <CategoryLink category={category}>
                <Image
                  critical={true}
                  aspect={aspect}
                  crop={true}
                  alt={name}
                  src={src}
                  sizes={[1, 1, 1 / 2, 1 / 2]}
                  cover
                  quality={80}
                />
              </CategoryLink>
            </Wrapper>
          );
        else return null;
      }}
    </CategoryContent>
  );
};
